const color = {
	attrs: { color: { default: null } },
};

export default color;
